import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { createSite } from 'redux/modules/model/site'
import { listClients } from 'redux/modules/model/client'
import { clientsSelector } from 'redux/selectors'
import { SiteForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import { wsClient } from 'index';
import { notification } from 'elements';
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class SiteAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createSite: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
  };

  state = {
		loading: false,
	};

  componentDidMount() {
    const { clientId, listClients } = this.props
    listClients({ clientId })
  }

  openNotificationWithIcon = (type, title, msg) => {
		notification[type]({
			placement: 'bottomLeft',
			duration: 7,
			message: `${title}`,
			description: `${msg}`,
		});
	};

  handleSubmit = actions => {
		const { history } = this.props;
		const operations = Object.freeze({
			createSite: payload => {
				this.setState({ loading: true });
				wsClient.request(
					{
						messageType: 'core.site.create-site',
						payload,
					},
					res => {
						this.setState({ loading: false });
						if (res.payload) {
							this.openNotificationWithIcon(
								'error',
								'Error',
								'Site already exists',
							);
						} else {
							this.openNotificationWithIcon(
								'success',
								'Success',
								'Site added successfully',
							);
							history.goBack();
						}
					},
				);
			},
		});
		actions.createSite && operations.addHolder(actions.createSite);
	};

  render() {
    const { clientList } = this.props
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.SITE}>&laquo; Back</Link></p>
          <PageContentTitle>Add a new site</PageContentTitle>
          <SiteForm onSubmit={this.handleSubmit} clients={clientList} />
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector
})

export const actions = {
  createSite,
  listClients
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(SiteAdd)



// WEBPACK FOOTER //
// ./src/pages/site/site-add/index.js